import { Component, OnInit } from '@angular/core';
import { MessageService, Message } from 'primeng/api';
import { ScheduleService } from 'src/app/services/schedule.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { IHearingDate } from '../../shared/classes/hearing-date';

@Component({
  selector: 'view-minutes',
  templateUrl: './view-minutes.component.html',
})

export class ViewMinuteComponent implements OnInit {

    hearingDateList: IHearingDate[];

    displayState: any = {
        workingDiv: false,
        gridDiv: false,
    };

    constructor(private messageService: MessageService, private schedService: ScheduleService,
                private utilService: UtilitiesService) { }

    ngOnInit() {
        this.displayState.gridDiv = false;
        this.getHearingDates();
    }

    // get list of defined Hearing Dates (for NON-FUTURE dates ONLY!)
    getHearingDates() {
        //console.log('getting hearing dates...');
        this.displayState.workingDiv = true;
        this.displayState.gridDiv = false;
        var tdy = new Date();
        this.schedService.getHearingDates().subscribe(data => {
            if (data) {
                this.hearingDateList = data.filter(t=> {
                var tHearDt = new Date(t.hearingDate)
                return tHearDt > tdy? null: t
                });
            }
            this.displayState.workingDiv = false;
            this.displayState.gridDiv = true;
        })
    }
    onSelectHearing(hearing: IHearingDate) {
      let hearingId = hearing.id;
      this.utilService.doAudit(hearing,'selected hearing');
      this.schedService.generateMinutesPdf(hearingId).subscribe(data => {
        this.utilService.doAudit('got response from generateMinutesPdf:');
        if (data) {
          const myUrl = URL.createObjectURL(data);
          window.open(myUrl, '_blank');
          URL.revokeObjectURL(myUrl);
        }
      })
    }
    onSelectMinuteOrder(hearing: IHearingDate) {
      let hearingId = hearing.id;
      this.utilService.doAudit(hearing,'selected hearing');
      this.schedService.generateMinuteOrdersPdf(hearingId).subscribe(data => {
        this.utilService.doAudit('got response from generateMinuteOrdersPdf:');
        if (data) {
          const myUrl = URL.createObjectURL(data);
          window.open(myUrl, '_blank');
          URL.revokeObjectURL(myUrl);
        }
      })
    }
  onSelectMinuteOrderLabels(hearing: IHearingDate) {
    let hearingId = hearing.id;
    this.utilService.doAudit(hearing,'selected hearing');
    this.schedService.generateMinuteOrderLabels(hearingId).subscribe(data => {
      this.utilService.doAudit('got response from generateMinuteOrderLabels:');
      if (data) {
        const myUrl = URL.createObjectURL(data);
        window.open(myUrl, '_blank');
        URL.revokeObjectURL(myUrl);
      }
    })
  }

      showToast(msg: Message) {
        this.messageService.add(msg);
      }

      showConfirm() {
        this.messageService.clear();
        this.messageService.add({key: 'c', sticky: true, severity: 'warn', summary: 'Are you sure?', detail: 'Confirm to proceed'});
      }


      onConfirm() {
          this.messageService.clear('c');
      }

      onReject() {
          this.messageService.clear('c');
      }

      clear() {
        this.messageService.clear();
      }

}
